export default __webpack_public_path__ + "static/badgeWhite-f029bd8a5d285923f4d52b4f58ffff42.svg";